import { IUnit } from './IUnit';
import { IStock } from './IStock';
import { IStore } from '../../pages/stores/core/interfaces/IStore';

export interface IArticleVariant {
  articleId?: number;
  articleName?: string;
  articleVariantConfigurationId?: number;
  ean?: string;
  id?: number;
  isDefault?: boolean;
  labelKey?: string;
  name?: string;
  orderNumber?: string;
  fullName?: string;
  packUnit?: string;
  unitId?: number;
  purchaseUnit?: number;
  stockMin?: number;
  isActive?: boolean;
  isActiveForProduction?: boolean;
  unit?: IUnit;
  weight?: number;
  stocks?: IStock[];
  isEdited?: boolean;
  customWeight?: number;
  isNotRelevantForPacking?: boolean;
  needsGermanLabel?: boolean;
  storageLocationNumber?: string;
  supplierOrderNumber?: string;
  mhd?: string;
  storeLocations?: IStoreLocation[];
  storageInfos: { storeId: number; storageLocationNumber: string; }[];
  baseReorderMultiply?: number;
  mhdOfferCounter?: number;
  mhdOfferSalesPercent?: number;
}

export interface IStoreLocation  {
  articleVariantId: number;
  store: IStore;
  storageLocation: string;
  minInStock: number;
}
